import { render } from "./TrackingHistory.vue?vue&type=template&id=2136b2f2"
import script from "./TrackingHistory.vue?vue&type=script&lang=js"
export * from "./TrackingHistory.vue?vue&type=script&lang=js"

import "./TrackingHistory.vue?vue&type=style&index=0&id=2136b2f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__